'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _constants = require('api/pipo/constants');

var constants = _interopRequireWildcard(_constants);

var _config = require('config/config.pipo');

var _config2 = _interopRequireDefault(_config);

var _IBonusError = require('api/IBonusError');

var _IBonusError2 = _interopRequireDefault(_IBonusError);

var _isString = require('lodash/isString');

var _isString2 = _interopRequireDefault(_isString);

var _Factory = require('Models/Factory');

var _Factory2 = _interopRequireDefault(_Factory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PIPOApi = function () {
    function PIPOApi(client) {
        var _this = this;

        (0, _classCallCheck3.default)(this, PIPOApi);

        this._send = function (path, data) {
            return _this.client.post(path, { data: data }, _config2.default.pipoHost);
            // .then((result) =>{
            //
            //     let status = !!result.status;
            //
            //     if(status){
            //         return result.result;
            //     }else{
            //
            //     }
            // });
        };

        this.client = client;
    }

    (0, _createClass3.default)(PIPOApi, [{
        key: 'getApiKey',
        value: function getApiKey(userId) {
            return this._send(constants.PIPO_PATH_GET_API_KEY, { id_user: userId }).then(function (result) {
                if (result && result.result) {
                    return result.result;
                }

                return result;
            });
        }
    }, {
        key: 'login',
        value: function login(_login, password) {
            var checkCode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            var fields = { login: _login, password: password };

            if (checkCode) {
                fields['check_code'] = checkCode;
            }

            return this._send(constants.PIPO_PATH_LOGIN, fields);
        }
    }, {
        key: 'getInputGroupsByPaymentInId',
        value: function getInputGroupsByPaymentInId(paymentInId, user_id, api_key) {
            return this._send(constants.PIPO_PATH_GET_INPUT_GROUPS_BY_PAYMENT_IN_ID, {
                paymentInId: paymentInId, user_id: user_id, api_key: api_key
            });
        }
    }, {
        key: 'getPaymentsParamsFromPIPObyId',
        value: function getPaymentsParamsFromPIPObyId(shopPipoId) {
            return this._send(constants.PIPO_PATH_GET_GET_BY_ID, {
                id_shop: shopPipoId
            }).then(function (data) {
                return _Factory2.default.create('ShopParameters', data.result);
            });
        }

        // getPaymentsParamsFromPIPObyId(shopPipoId) {
        //     // console.log(shopPipoId);
        //     const data = require('./params.json');
        //
        //     return Promise.resolve(new ShopParameters(data.result));
        // }

    }, {
        key: 'getDetailPayIn',
        value: function getDetailPayIn(id_operation, id_user, api_key) {
            return this._send(constants.PIPO_PATH_GET_DETAIL_PAYIN, {
                id_operation: id_operation, id_user: id_user, api_key: api_key
            });
        }
    }, {
        key: 'getLang',
        value: function getLang(lang) {
            var langCrutch = '';
            switch (lang) {
                case 'ru':
                    langCrutch = 'ru';
                    break;
                case 'rus':
                    langCrutch = 'ru';
                    break;
                case 'kaz':
                    langCrutch = 'ru';
                    break;
                case 'ukr':
                    langCrutch = 'ru';
                    break;
                case 'en':
                    langCrutch = 'en';
                    break;
                case 'eng':
                    langCrutch = 'en';
                    break;
                case 'gbr':
                    langCrutch = 'en';
                    break;
                case 'eur':
                    langCrutch = 'en';
                    break;
                default:
                    langCrutch = 'ru';
                    break;
            }

            return this.client.getRaw('lang/' + langCrutch + '.json', _config2.default.pipoHost).then(function (text) {
                return JSON.parse(text);
            });
        }
    }, {
        key: 'processInput',
        value: function processInput(params) {
            return this.client.get(constants.PIPO_PATH_PROCESS_INPUT, { params: params }, _config2.default.pipoHost).then(function (result) {
                return result;
                var status = !!result.status;

                if (status) {
                    return result.result;
                } else {
                    var message = '',
                        title = '',
                        code = 0,
                        trace = '';
                    if ((0, _isString2.default)(result.result)) {
                        message = result.result;
                        title = result.result;
                    } else if (result.hasOwnProperty('user_msg')) {
                        message = result.user_msg;
                        title = result.user_msg;
                    } else {
                        message = result.result.error.message || '';
                        title = result.result.title || 0;
                        code = result.result.code || 0;
                        trace = result.result.error.trace || '';
                    }
                    throw new _IBonusError2.default({
                        message: message,
                        title: title,
                        code: code,
                        trace: trace
                    });
                }
            });
        }
    }]);
    return PIPOApi;
}();

exports.default = PIPOApi;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/api/pipo/PIPOApi.js
// module id = 1592
// module chunks = 0